const initVenueAccordion = () => {
  const accordion = document.querySelector('[data-venue-accordion]')
  if (!accordion) return

  const items = Array.from(accordion.querySelectorAll('[data-accordion-item]'))
  if (!items.length) return

  const openItem = (item) => {
    const arrow = item.querySelector('[data-arrow-icon]')
    const contentWrapper = item.querySelector('[data-card-content-wrapper]')
    if (arrow) arrow.classList.add('rotate-180')
    if (contentWrapper) contentWrapper.style.gridTemplateRows = '1fr'
    item.dataset.open = 'true'
  }

  const closeItem = (item) => {
    const arrow = item.querySelector('[data-arrow-icon]')
    const contentWrapper = item.querySelector('[data-card-content-wrapper]')
    if (arrow) arrow.classList.remove('rotate-180')
    if (contentWrapper) contentWrapper.style.gridTemplateRows = '0fr'
    item.dataset.open = 'false'
  }

  items.forEach((item) => {
    closeItem(item)
  })

  accordion.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-accordion-trigger]')
    if (!trigger) return
    const item = trigger.closest('[data-accordion-item]')
    if (!item) return
    const isOpen = item.dataset.open === 'true'
    items.forEach((other) => { if (other !== item) closeItem(other) })
    isOpen ? closeItem(item) : openItem(item)
  })
}

export default initVenueAccordion
